import { Col, Container, Row } from "react-bootstrap";

import React from "react";
import TableEstudiantes from "../../DataTables/Estudiante/TableEstudiantes";

const DashboardEstudiantes = ({ isTabActive }) => {
  // const handleAgregarEstudiante = () => {};

  // const [ estudianteAgregado, setEstudianteAgregado ] = useState(false);

  return (
    isTabActive && (
      <Container fluid className="pt-3">
        {/* <Row>
                    <Col align='right'>
                        <Button variant="primary" onClick={handleAgregarEstudiante}>Agregar empleado</Button>
                    </Col>
                </Row> */}

        <Row className="mt-3">
          <Col>
            <TableEstudiantes />
          </Col>
        </Row>
      </Container>
    )
  );
};

export default DashboardEstudiantes;
